import {
  HomeIcon,
  SignalIcon,
  BeakerIcon,
  InboxIcon,
  UserGroupIcon,
  LightBulbIcon,
  BookOpenIcon,
  CalendarDaysIcon,
  CreditCardIcon,
  Cog6ToothIcon,
  GlobeAltIcon,
  ChatBubbleBottomCenterTextIcon,
  MicrophoneIcon,
  UsersIcon,
  ArrowPathIcon,
  CurrencyDollarIcon,
  MagnifyingGlassIcon,
  ClipboardDocumentListIcon,
  MapIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
import type { NavItem } from '@/types/nav';

export const tenantNavItems: NavItem[] = [
  { id: 'home', label: 'Dashboard', icon: HomeIcon, path: '/tenant/home' },
  { id: 'help', label: 'Help', icon: QuestionMarkCircleIcon, path: '/tenant/help' },
  { id: 'inbox', label: 'Inbox', icon: InboxIcon, path: '/tenant/inbox/conversations' },
  { id: 'whatsapp-flow', label: 'How chat works', icon: MapIcon, path: '/tenant/whatsapp-flow' },
  {
    id: 'channels',
    label: 'Channels',
    icon: SignalIcon,
    path: '/tenant/channels/web',
    children: [
      { id: 'web', label: 'Web Chat', icon: GlobeAltIcon, path: '/tenant/channels/web' },
      { id: 'whatsapp', label: 'WhatsApp', icon: ChatBubbleBottomCenterTextIcon, path: '/tenant/channels/whatsapp' },
      { id: 'voice', label: 'Voice AI', icon: MicrophoneIcon, path: '/tenant/channels/voice', badge: 'Beta' },
      { id: 'test', label: 'Test', icon: BeakerIcon, path: '/tenant/channels/test' },
    ],
  },
  {
    id: 'crm',
    label: 'CRM',
    icon: UserGroupIcon,
    path: '/tenant/crm/follow-ups',
    children: [
      { id: 'followups', label: 'Follow-ups', icon: ClipboardDocumentListIcon, path: '/tenant/crm/follow-ups' },
      { id: 'leads', label: 'Leads', icon: UsersIcon, path: '/tenant/crm/leads' },
      { id: 'contacts', label: 'Contacts', icon: MagnifyingGlassIcon, path: '/tenant/crm/contacts' },
      { id: 'deals', label: 'Deals', icon: CurrencyDollarIcon, path: '/tenant/crm/deals' },
    ],
  },
  { id: 'knowledge', label: 'Knowledge', icon: BookOpenIcon, path: '/tenant/knowledge' },
  { id: 'calendar', label: 'Calendar', icon: CalendarDaysIcon, path: '/tenant/calendar' },
  {
    id: 'insights',
    label: 'Insights',
    icon: LightBulbIcon,
    path: '/tenant/insights/bot-health',
    children: [
      { id: 'health', label: 'Bot Health', icon: MagnifyingGlassIcon, path: '/tenant/insights/bot-health' },
      { id: 'activity', label: 'Activity Log', icon: ArrowPathIcon, path: '/tenant/insights/activity' },
    ],
  },
  { id: 'billing', label: 'Billing', icon: CreditCardIcon, path: '/tenant/billing' },
  { id: 'settings', label: 'Settings', icon: Cog6ToothIcon, path: '/tenant/settings/profile' },
  // Removed: Simulators (merged into Channels), Integrations (placeholder), Analytics (placeholder)
];

/** Reduced navigation for non-technical tenants (default view mode). */
export const simpleTenantNavItems: NavItem[] = [
  { id: 'home', label: 'Today', icon: HomeIcon, path: '/tenant/home' },
  { id: 'help', label: 'Help', icon: QuestionMarkCircleIcon, path: '/tenant/help' },
  { id: 'inbox', label: 'Messages', icon: InboxIcon, path: '/tenant/inbox/conversations' },
  { id: 'whatsapp-flow', label: 'How chat works', icon: MapIcon, path: '/tenant/whatsapp-flow' },
  { id: 'knowledge', label: 'Knowledge', icon: BookOpenIcon, path: '/tenant/knowledge' },
  {
    id: 'crm',
    label: 'Customers',
    icon: UserGroupIcon,
    path: '/tenant/crm/follow-ups',
    children: [
      {
        id: 'followups',
        label: 'Waiting for reply',
        icon: ClipboardDocumentListIcon,
        path: '/tenant/crm/follow-ups',
      },
      {
        id: 'appointments',
        label: 'Bookings',
        icon: CalendarDaysIcon,
        path: '/tenant/crm/appointments',
      },
      {
        id: 'contacts',
        label: 'All customers',
        icon: MagnifyingGlassIcon,
        path: '/tenant/crm/contacts',
      },
      {
        id: 'leads',
        label: 'New enquiries',
        icon: UsersIcon,
        path: '/tenant/crm/leads',
      },
    ],
  },
  {
    id: 'try-chat',
    label: 'Try chat',
    icon: BeakerIcon,
    path: '/tenant/channels/test',
  },
  { id: 'calendar', label: 'Calendar', icon: CalendarDaysIcon, path: '/tenant/calendar' },
  { id: 'billing', label: 'Billing', icon: CreditCardIcon, path: '/tenant/billing' },
  { id: 'settings', label: 'Settings', icon: Cog6ToothIcon, path: '/tenant/settings/profile' },
];